export const truncateString = (str, num) => {
  if (!str) {
    return '';
  }

  if (str?.length <= num) {
    return str;
  }

  let string = str?.slice(0, num);

  if (string.slice(-1) !== ' ') {
    const stringArray = string.split(' ');
    stringArray.pop();
    string = `${stringArray.toString().split(',').join(' ')}`;
  }

  return `${string}...`;
};
